/* mm-swap v12: troca de cor sem estados intermediarios. Antes de qualquer troca (Par 1 ou Par 2) tira uma "foto" viva do bloco de ofertas (fantasma, ja mostrando a cor nova), esconde o bloco real enquanto Kaching e os scripts refazem tudo, e so devolve o real quando estiver estavel. A troca de cor do Par 1 (antes no footer-group) fica aqui, sem escurecer a secao. Revert: publicar o tema v11. */
(function(){
  if(window.__mmSw)return;window.__mmSw=1;
  var D=document,HTML=D.documentElement;
  var css=D.createElement('style');css.setAttribute('data-mm','swap');
  css.textContent='html.mm-hold kaching-bundle{display:none !important}.mm-ghost{pointer-events:none !important;-webkit-user-select:none;user-select:none}';
  D.head.appendChild(css);
  function $$(s,r){return[].filter.call((r||D).querySelectorAll(s),function(x){return!x.closest('.mm-ghost')})}
  function $(s,r){return $$(s,r)[0]||null}
  function B(){return window.__mmB||{}}
  function handleOf(u){return((String(u).split('/products/')[1]||'').split(/[?#]/)[0])}
  function handleNow(){return handleOf(location.pathname)}
  function cname(t){return String(t).split(' - ').slice(1).join(' - ')||t}
  function small(src,w){return String(src).replace(/^\/\//,'https://').replace(/(\.\w+)(\?|$)/,'_'+w+'x'+w+'$1$2')}
  function decoded(u,ms){var i=new Image();i.src=u;return Promise.race([i.decode?i.decode().catch(function(){}):Promise.resolve(),new Promise(function(r){setTimeout(r,ms)})])}

  /* ---------- fantasma do bloco Kaching ---------- */
  var G={el:null,timer:0};
  function patch(g,idx,p){
    if(!p)return;
    try{
      var bar=g.querySelector('.kaching-bundles__bar--selected');if(!bar)return;
      var c=bar.querySelectorAll('.kaching-bundles__collection-product')[idx];if(!c)return;
      var t=c.querySelector('.kaching-bundles__collection-product__title');if(t)t.textContent=p.title;
      var im=c.querySelector('img.kaching-bundles__collection-product__image'),f=p.images&&p.images[0];
      if(im&&f){var u=small(f.src,200);decoded(u,1500).then(function(){if(G.el===g){im.removeAttribute('srcset');im.src=u}})}
      var sw=c.querySelector('.mm-swb');
      if(sw){
        [].forEach.call(sw.querySelectorAll('.mm-sw__i'),function(x){x.classList.toggle('is-cur',x.getAttribute('data-h')===p.handle)});
        var s=sw.querySelector('.mm-swb__lab strong');if(s)s.textContent=cname(p.title);
      }
    }catch(e){}
  }
  function hold(idx,p){
    if(G.el)return true;
    var k=$('kaching-bundle'),kb=k&&$('.kaching-bundles',k);
    if(!kb||!kb.offsetHeight)return false;
    var g=kb.cloneNode(true),o=kb.querySelectorAll('select'),c=g.querySelectorAll('select');
    for(var i=0;i<c.length;i++){if(o[i])c[i].value=o[i].value}
    [g].concat([].slice.call(g.querySelectorAll('*'))).forEach(function(e){
      ['id','name','for','form','href','target','tabindex','loading'].forEach(function(a){e.removeAttribute(a)});
    });
    g.classList.add('mm-ghost');g.setAttribute('aria-hidden','true');g.setAttribute('inert','');
    k.parentNode.insertBefore(g,k.nextSibling);
    HTML.classList.add('mm-hold');G.el=g;
    patch(g,idx,p);
    clearTimeout(G.timer);G.timer=setTimeout(drop,5000);
    return true;
  }
  /* depois que a secao foi trocada, o Kaching ainda nao inseriu o bloco novo: o fantasma fica no lugar dele (logo antes do formulario de compra) */
  function rehome(){
    if(!G.el)return;
    var k=$('kaching-bundle'),pf=D.querySelector('product-form.main-product-form');
    if(k){if(G.el.parentNode!==k.parentNode)k.parentNode.insertBefore(G.el,k.nextSibling)}
    else if(pf)pf.parentNode.insertBefore(G.el,pf);
  }
  function drop(){
    clearTimeout(G.timer);
    if(G.el){G.el.remove();G.el=null}
    HTML.classList.remove('mm-hold');
  }
  /* espera a condicao e 150ms sem nenhuma mudanca no DOM da coluna (fora do fantasma) */
  function stable(cond,cap){
    return new Promise(function(res){
      var t0=Date.now(),last=t0;
      var mo=new MutationObserver(function(ms){
        for(var i=0;i<ms.length;i++){var t=ms[i].target,e=t&&t.nodeType===1?t:t&&t.parentNode;if(!(e&&e.closest&&e.closest('.mm-ghost'))){last=Date.now();break}}
      });
      mo.observe(D.querySelector('.product__info-wrapper')||D.body,{childList:true,subtree:true,attributes:true,characterData:true});
      (function tick(){
        var now=Date.now(),ok=false;try{ok=cond()}catch(e){}
        if((ok&&now-last>=150)||now-t0>cap){mo.disconnect();res(ok)}else setTimeout(tick,30);
      })();
    });
  }
  function p2ok(t){
    return function(){
      if(HTML.classList.contains('mm-quiet'))return false;
      var pn=$('.mm-p2v');if(pn&&pn.getAttribute('data-h')!==t)return false;
      return!!$('.mm-swb[data-k^="p2"] .mm-sw__i.is-cur[data-h="'+t+'"]');
    };
  }
  function p1ok(t){
    return function(){
      if(handleNow()!==t||HTML.classList.contains('mm-quiet')||!$('kaching-bundle .kaching-bundles__bar'))return false;
      var cs=$$('.kaching-bundles__bar--selected .kaching-bundles__collection-product'),sw=$$('.kaching-bundles__bar--selected .mm-swb');
      if(cs.length&&(sw.length<cs.length||!$('.mm-swb[data-k^="p1"] .mm-sw__i.is-cur[data-h="'+t+'"]')))return false;
      var im=$('media-gallery img');if(im&&!(im.complete&&im.naturalWidth))return false;
      if(window.matchMedia('(max-width:749px)').matches){var d=$('.mm-dots');if(!d||d.getAttribute('data-h')!==t)return false;var pi=d.querySelector('.mm-dots__pic img');if(pi&&!(pi.complete&&pi.naturalWidth))return false}
      return true;
    };
  }
  window.__mmG={
    hold:hold,
    release:function(t){return stable(p2ok(t),3500).then(drop)}
  };

  /* ---------- troca de cor do Par 1 (a pagina do outro produto entra no lugar, sem recarregar) ---------- */
  var pages={},warmed={},keep=[],busy=false;
  function get(u){return pages[u]||(pages[u]=fetch(u,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw 0;return r.text()}).catch(function(e){delete pages[u];throw e}))}
  function imgLike(i){var im=new Image();if(i.getAttribute('sizes'))im.sizes=i.getAttribute('sizes');if(i.getAttribute('srcset'))im.srcset=i.getAttribute('srcset');im.src=i.getAttribute('src')||'';return im}
  function warmDoc(doc){
    [].slice.call(doc.querySelectorAll('media-gallery img')).slice(0,12).forEach(function(i){keep.push(imgLike(i))});
    while(keep.length>40)keep.shift();
  }
  function pic(p){var s=String(p.images[0].src).replace(/^\/\//,'https://');return s+(s.indexOf('?')>-1?'&':'?')+'width=120'}
  function warm(u){
    if(warmed[u])return;warmed[u]=1;
    get(u).then(function(h){warmDoc(new DOMParser().parseFromString(h,'text/html'))}).catch(function(){warmed[u]=0});
    try{var h=handleOf(u);Promise.resolve(B().prods&&B().prods(B().colOfHandle(handleNow()))).then(function(l){var p=(l||[]).filter(function(x){return x.handle===h})[0];if(p&&p.images&&p.images[0]){keep.push((function(){var i=new Image();i.src=small(p.images[0].src,200);return i})());keep.push((function(){var i=new Image();i.src=pic(p);return i})())}})}catch(e){}
  }
  function curSize(){var i=D.querySelector('variant-selects input:checked');return i?i.value:null}
  function reexec(root){
    [].forEach.call(root.querySelectorAll('script'),function(o){var s=D.createElement('script');[].forEach.call(o.attributes,function(a){s.setAttribute(a.name,a.value)});s.text=o.textContent;o.parentNode.replaceChild(s,o)});
  }
  function put(doc,sec,nsec,url){
    ['kaching-bundles-product','kaching-bundles-deal-block-settings'].forEach(function(c){
      var olds=D.querySelectorAll('script.'+c),anchor=olds[0];
      doc.querySelectorAll('script.'+c).forEach(function(n){var s=D.createElement('script');[].forEach.call(n.attributes,function(a){s.setAttribute(a.name,a.value)});s.text=n.textContent;(anchor?anchor.parentNode:D.body).insertBefore(s,anchor||null)});
      [].forEach.call(olds,function(o){o.remove()});
    });
    sec.innerHTML=nsec.innerHTML;reexec(sec);
    D.title=doc.title;history.replaceState(null,'',url);
  }
  async function p1(e,a){
    e.preventDefault();e.stopImmediatePropagation();
    if(a.classList.contains('is-current')||busy)return;
    var url=a.href,h=handleOf(url),size=curSize(),sec=D.querySelector('.shopify-section[id$=__main]');
    if(!sec||!h){location.href=url;return}
    busy=true;
    try{
      var col=B().colOfHandle?B().colOfHandle(handleNow()):'malibulun';
      var list=B().prods?await B().prods(col):[],p=list.filter(function(x){return x.handle===h})[0];
      hold(0,p);
      [].forEach.call(D.querySelectorAll('.mm-col__item.is-current'),function(x){x.classList.remove('is-current');x.removeAttribute('aria-current')});
      a.classList.add('is-current');a.setAttribute('aria-current','true');
      var html=await get(url),doc=new DOMParser().parseFromString(html,'text/html'),nsec=doc.getElementById(sec.id);
      if(!nsec)throw 0;
      warmDoc(doc);
      var g0=nsec.querySelector('media-gallery img');
      var pre=[];
      if(g0){var gi=imgLike(g0);pre.push(gi.decode?gi.decode().catch(function(){}):0)}
      if(p&&p.images&&p.images[0])pre.push(decoded(pic(p),1200));
      await Promise.race([Promise.all(pre),new Promise(function(r){setTimeout(r,1200)})]);
      put(doc,sec,nsec,url);
      rehome();
      if(B().relabel)B().relabel(B().wasTwo());
      if(B().ensureTiles)await B().ensureTiles();
      if(B().relabel)B().relabel(B().wasTwo());
      if(window.kachingBundlesInitialize)window.kachingBundlesInitialize();
      if(size){var ins=sec.querySelectorAll('variant-selects input');for(var i=0;i<ins.length;i++){if(ins[i].value===size&&!ins[i].checked){ins[i].click();break}}}
      if(B().ensureDots)await B().ensureDots();
      if(B().schedule)B().schedule();
      var t=sec.getBoundingClientRect().top;if(t<-40)window.scrollTo({top:window.pageYOffset+t-70,behavior:'smooth'});
      await stable(p1ok(h),3500);
    }catch(err){
      if(location.pathname.indexOf(h)<0){drop();busy=false;location.href=url;return}
    }
    drop();busy=false;
  }
  window.addEventListener('click',function(e){
    if(e.defaultPrevented||e.metaKey||e.ctrlKey||e.shiftKey||e.button||!e.target.closest)return;
    var a=e.target.closest('a.mm-col__item');
    if(a)p1(e,a);
  },true);
  ['pointerover','touchstart','pointerdown'].forEach(function(ev){
    D.addEventListener(ev,function(e){var a=e.target.closest&&e.target.closest('a.mm-col__item');if(a&&!a.classList.contains('is-current'))warm(a.href)},{passive:true});
  });
})();
